
import { Component, Vue } from 'vue-property-decorator';
import { mainStore, leagueStore, userActionStore } from '@/store';
import ShowPopup from '@/components/ShowPopup.vue';
import ListRanking from './ListRanking.vue';

@Component({
  components: { ShowPopup, ListRanking },
})
export default class Dashboard extends Vue {
  public isLoading = false;
  public league_entry = [];
  srcMobile = 'https://mail.knnidiomas.com.br/knn-master/league_entry_mobile.png';
  srcDesktop = 'https://mail.knnidiomas.com.br/knn-master/league_entry_2.png';

  winners = [
    { category: 'Master', nome_fantasia: 'KNN BLUMENAU', points: '87,6' },
    { category: 'Plena', nome_fantasia: 'KNN PONTA PORA', points: '67,2' },
    { category: 'Compacta', nome_fantasia: 'KNN SARANDI - RS', points: '77' },
  ];

  get currentUser() {
    return mainStore.userProfile;
  }

  get temInscricao() {
    return this.league_entry.find((item) => item.company_id === this.currentUser.company_id) ? true : false;
  }

  public handleLeagueRanking() {
    //this.$router.push({ name: "main-league-entry-ranking" });

    let form: any = this.$refs.showRanking;
    form.show();
  }

  public handleLeagueList() {
    this.$router.push({ name: 'main-league-entry-list' });
  }

  public handleLeagueEtapas() {
    this.$router.push({ name: 'main-league-entry-etapas' });
  }

  public handleLeagueEntry() {
    this.$router.push({ name: 'main-league-entry-create' });
  }

  get getImage() {
    if (this.$vuetify.breakpoint.mobile) {
      return this.srcMobile;
    } else {
      return this.srcDesktop;
    }
  }

  get HabilitarBotaoConferenciaLigaKNN() {
    return userActionStore.HabilitarBotaoConferenciaLigaKNN;
  }

  // get hasPermissionConferencia() {
  //   if (!this.currentUser) return false;

  //   return (
  //     this.currentUser.franchising_id === 1 &&
  //     this.currentUser.company_id === 1 &&
  //     (this.currentUser.is_superuser || this.HabilitarBotaoConferenciaLigaKNN)
  //   );
  // }

  public handleShowRegulation() {
    window.open('https://mail.knnidiomas.com.br/knn-master/TripKNNRegulamento.pdf', '_blank');
  }

  public async mounted() {
    this.isLoading = true;

    await mainStore.userProfile;

    let id = 2;
    this.league_entry = await leagueStore.getLeagueEntryAll(id);

    this.isLoading = false;
  }
}
